<template lang="pug">
	.appr-result(v-if="poiTypes")
		.appr-place
			h2.appr-place__title
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="26" viewBox="0 0 24 26">
					<g fill="none" fill-rule="evenodd" stroke="#767676" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" transform="translate(1.5 1.75)">
						<circle cx="10.5" cy="6.75" r="3"/>
						<path d="M10.5 0a6.75 6.75 0 0 1 6.75 6.75c0 3.251-5.132 10.527-6.446 12.337a.377.377 0 0 1-.608 0C8.882 17.277 3.75 10.001 3.75 6.75A6.75 6.75 0 0 1 10.5 0z"/>
						<path d="M16.479 17.034C19.211 17.575 21 18.478 21 19.5c0 1.657-4.7 3-10.5 3S0 21.157 0 19.5c0-1.02 1.781-1.921 4.5-2.463"/>
					</g>
				</svg>
				span A becsült ingatlan címe
			p.appr-place__location {{results.estate.address}}
		section.appr-result-map-container(aria-labelledby="appr-map-ctr")
			.appr-result-map-container__header
				h2#appr-map-ctr.heading-1 Nézze meg, mi van a környéken
				.appr-multiselect-wrapper(v-if="isMobile")
					VueMultiSelect#appr-sf-poi-type(v-model="model.poiTypes", :options="poiTypes")
				.appr-checkbox-wrapper(v-else)
					template(v-for="poiType in poiTypes")
						VueCheckbox(v-model="model.poiTypes", :checked-value="poiType.key", :background="poiType.color")
							| {{poiType.value}}
			GmapMap(ref="map", :center="center", :zoom="zoom", style="height: 500px")
				GmapInfoWindow(v-if="selectedMarker", :options="infoOptions", :position="infoWindowPos", :opened="infoWinOpen", @closeclick="infoWinOpen=false")
					div
						h6 {{selectedMarker.title}}
						p(v-if="selectedMarker.address") {{selectedMarker.address}}
						hr
						p
							span
								svg(xmlns="http://www.w3.org/2000/svg", width="24", height="24", viewbox="0 0 24 24")
									g(fill="none", fill-rule="evenodd", stroke="#9E9E9E", stroke-linecap="round", stroke-linejoin="round", stroke-width="2")
										path(d="M15.182 2.818a4.5 4.5 0 1 1-6.364 6.364 4.5 4.5 0 0 1 6.364-6.364M11.625 4.5c.207 0 .375.168.375.375M11.25 4.875c0-.207.168-.375.375-.375M11.625 5.25a.375.375 0 0 1-.375-.375M12 4.875a.375.375 0 0 1-.375.375M12 10.5v8.25M15 15.155c4.338.461 7.5 1.9 7.5 3.6 0 2.071-4.7 3.75-10.5 3.75S1.5 20.821 1.5 18.75c0-1.7 3.149-3.127 7.471-3.592")
								| {{selectedMarker.distance | distance}} kilométerre
							a(:href="`https://www.google.hu/maps/dir/${estatePosition.lat},${estatePosition.lng}/${selectedMarker.position.lat},${selectedMarker.position.lng}`", target="_blank")
								svg(xmlns="http://www.w3.org/2000/svg", width="24", height="24", viewbox="0 0 24 24")
									g(fill="none", fill-rule="evenodd", stroke="#390", stroke-linecap="round", stroke-linejoin="round", stroke-width="1.5", transform="translate(1 1)")
										circle(cx="11", cy="11", r="11")
										path(d="M6.249 16.135c-.977 0-2.932-5.865.978-5.865h9.286")
										path(d="M13.685 13.203l2.932-2.933-2.932-2.932")

								| Odanavigálok
				GmapMarker(:key="index", v-for="(marker, index) in poiMarkers", :position="marker.position", :z-index="50", :icon="require(`@/assets/gmap/${marker.color}.svg`)"  :clickable="true", @click="toggleInfoWindow(marker,index)")
				GmapMarker(:position="estatePosition", :z-index="60", :icon="require('@/assets/gmap/estimated-property.svg')", :clickable="false")
		template(v-if="customerFooter")
			slot(name="result-footer-content-customer")
		template(v-if="vendorFooter")
			slot(name="result-footer-content-vendor")
</template>

<script>
import VueMultiSelect from '@ui-common/vue-multi-select';
import VueCheckbox from '@ui-common/vue-checkbox';
import { FORM_TYPES, GTM_FORM_TYPES } from '../common/constants';
import { isMobile } from '../common/mixins/is-mobile';
const svgModules = require.context('@/assets/gmap', false, /\.svg$/);
svgModules.keys().forEach(svgModules);
export default {
	name: 'AppraiserResults',
	mixins: [isMobile],
	data: () => ({
		map: null,
		selectedMarker: null,
		infoWinOpen: false,
		infoWindowPos: null,
		currentMidx: null,
		center: {
			lat: 42,
			lng: 57
		},
		model: {
			poiTypes: []
		},
		infoOptions: {
			pixelOffset: {
				width: 0,
				height: -35
			}
		}
	}),
	props: {
		type: {
			required: true,
			type: String
		},
		results: Object,
		gtmPageInitResult: String,
		gtmPageInitPrefix: String
	},
	components: {
		VueMultiSelect,
		VueCheckbox
	},
	filters: {
		distance(val) {
			if (!val) return '';
			return new Intl.NumberFormat('hu-HU', { minimumFractionDigits: 0, maximumFractionDigits: 1, useGrouping: false }).format(val / 1000);
		}
	},
	watch: {
		poiTypes: {
			handler(val) {
				if (val) {
					this.model.poiTypes = val.map(poiType => poiType.value);
				}
			},
			immediate: true
		},
		poiMarkers: {
			handler() {
				this.fitBounds();
			},
			immediate: true
		},
		map: {
			handler() {
				this.fitBounds();
			},
			immediate: true
		}
	},
	computed: {
		customerFooter() {
			return this.type == FORM_TYPES.CUSTOMER && this.results.ingatlanhitel;
		},
		vendorFooter() {
			return this.type == FORM_TYPES.VENDOR && this.results.megkeresesHozzajarulas;
		},
		poiTypes() {
			return (
				this.results &&
				this.results.poi.filters.map(poi => {
					return {
						key: poi.type,
						value: poi.type,
						color: poi.color
					};
				})
			);
		},
		poiMarkers() {
			return (
				this.results &&
				this.results.poi.pois
					.filter(poi => this.model.poiTypes.includes(poi.filter))
					.map(poi => ({
						title: poi.name,
						position: { lat: poi.latitude, lng: poi.longitude },
						color: poi.color,
						distance: poi.distance,
						address: poi.address
					}))
			);
		},
		estatePosition() {
			return (
				this.results && {
					lat: this.results.estate.latitude,
					lng: this.results.estate.longitude
				}
			);
		},
		zoom() {
			return this.results ? this.results.defaultZoom : 13;
		}
	},
	methods: {
		fitBounds() {
			if (this.poiTypes && this.map) {
				/* eslint-disable */
				const bounds = new google.maps.LatLngBounds();
				/* eslint-enable */
				this.poiMarkers.forEach(marker => {
					/* eslint-disable */
					const loc = new google.maps.LatLng(marker.position.lat, marker.position.lng);
					/* eslint-enable */
					bounds.extend(loc);
				});
				/* eslint-disable */
				const estateLoc = new google.maps.LatLng(this.estatePosition.lat, this.estatePosition.lng);
				/* eslint-enable */
				bounds.extend(estateLoc);
				this.poiMarkers.length && this.map.fitBounds(bounds);
			}
		},
		toggleInfoWindow(marker, idx) {
			this.infoWindowPos = marker.position;
			this.selectedMarker = marker;
			if (this.currentMidx == idx) {
				this.infoWinOpen = !this.infoWinOpen;
			} else {
				this.infoWinOpen = true;
				this.currentMidx = idx;
			}
		},
		formatDistance(distance) {
			new Intl.NumberFormat('hu-HU').format(distance / 1000);
		}
	},
	mounted() {
		this.$refs.map.$mapPromise.then(map => {
			this.map = map;
		});
		window.scrollTo(0, 0);
	},
	created() {
		if (this.gtmPageInitResult && this.gtmPageInitPrefix) {
			const gtmPageType = `${this.gtmPageInitPrefix} - ${GTM_FORM_TYPES[this.type]} ${this.gtmPageInitResult}`;
			this.$gtm.trackEvent({
				event: 'pageInit',
				pageType: gtmPageType
			});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="@ui-common/vue-multi-select/dist/vue-multi-select.css"></style>
<style src="@ui-common/vue-checkbox/dist/vue-checkbox.css"></style>
<style scoped lang="scss">
@import '~@sfui/helpers/_queries.scss';
@import '~@sfui/helpers/_variables.scss';
@import '../common/mixins';

.appr-place__title {
	align-items: center;
	display: flex;
	font-family: 'Source Sans Pro', sans-serif;
	font-size: 16px;
	font-weight: normal;
	margin-bottom: 20px;
	justify-content: center;

	@media screen and ($tablet) {
		margin-bottom: 40px;
	}

	svg {
		margin-right: 10px;
	}
}

.appr-result-map-container .heading-1 {
	margin-bottom: 20px;
}

.appr-multiselect-wrapper {
	margin-bottom: 30px;
}

.appr-multiselect-wrapper .sf-multi-select__btn {
	padding: 0 20px;
}

.appr-multiselect-wrapper .sf-multi-select__options {
	position: relative;
}

.appr-place__location {
	font-size: 30px;
	font-weight: 600;
	line-height: 34px;
	margin-bottom: 30px;
	text-align: center;

	@media screen and ($tablet) {
		font-size: 42px;
		line-height: 46px;
		margin-bottom: 60px;
	}
}

.appr-result-map-container {
	@include pad-sides;
}

.appr-result-map-container {
	background-color: $gray-f5;
	margin-bottom: 20px;
	padding-bottom: 40px;
	padding-top: 40px;

	@media screen and ($tablet) {
		margin-bottom: 60px;
		padding: 40px 25px;
	}

	@media screen and ($desktop) {
		padding-left: 80px;
		padding-right: 80px;
	}
}

.appr-result-map-container__header .heading-1 {
	line-height: 30px;

	@media screen and ($tablet) {
		margin-bottom: 40px;
	}
}

.appr-map-container__inner {
	box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.2);
}

.appr-checkbox-wrapper {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 10px;
}

.appr-checkbox-wrapper .sf-checkbox {
	margin-bottom: 30px;
	margin-right: 30px;
}

.appr-result__footer {
	margin-bottom: 60px;
}

.gm-style .gm-style-iw-c {
	border-radius: 0 !important;
	max-width: 300px !important;
	padding: 15px !important;
}

.gm-style .gm-style-iw-d {
	overflow: auto !important;
}

.gm-style .gm-style-iw-d h6 {
	font-family: 'Source Sans Pro', sans-serif;
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 5px;
	margin-top: 0;
	text-transform: uppercase;
}

.gm-style .gm-style-iw-d p {
	font-family: 'Source Sans Pro', sans-serif;
	font-size: 14px;
	line-height: 24px;
	margin-bottom: 0;
}

.gm-style .gm-style-iw-d hr {
	margin: 10px 0;
}

.gm-style .gm-style-iw-d svg {
	display: inline-block;
	margin-right: 7px;
	vertical-align: top;
}

.gm-style .gm-style-iw-d span {
	padding-right: 20px;
}
</style>
